import React, {useEffect, useState} from "react";
import {connect} from 'react-redux';
import {Trans, useTranslation} from 'react-i18next';
import {
    Button,
    Card, CardBody,
    Col,
    Form,
    FormGroup,
    Input,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
} from 'reactstrap';
import axios from "axios";
import i18next from "i18next";

import bg from "../../assets/utils/images/bg-phone-right.png";

function NotFound(
    {}
) {
    const {t, i18n} = useTranslation();


    useEffect(() => {
        const url = new URL(window.location.toString().replace('/#/','/'));
        if (url.href.indexOf('acceptInvite') !== -1 && url.searchParams.get('inviteToken')) {
            //нам  пришел запрос на принятие инвайта. Принимаем его и показываем тост о том что у нас все получилось, или не получилось
            let inviteToken = url.searchParams.get('inviteToken');
            acceptingAnInvite(inviteToken);
        }
    })
    const acceptingAnInvite = (jwt_token) => {

        const instance = axios.create({
            baseURL: process.env.REACT_APP_API_URL,
            headers: {
                'Content-Type': 'application/json',
            },
        });

        instance.post('auth/obtain_operator_token_v2_mobile/', {jwt_token}).then(response => {
                if (response.data.status === 'ok') {
                    Toast.show({
                        text: i18next.t('thunks.accepting_an_invite_success', 'Invitation successfully accepted')
                    });
                } else {
                    Toast.show({
                        text: response.data.error
                    });
                }
            },
            error => {
                Toast.show({
                    text: i18next.t('errors.common.request_sent', 'Error occurred during accepting invitation')
                });
            })

    };

    return <>

        <div className="h-100 z-index-1">
            <div className="d-flex h-100 justify-content-center align-items-center">
                <Col xl="6" lg="8" md="10">
                    <div className="alert alert-success" role="alert">
                        <h5 className="m-0">
                            {i18next.t('pages.notFound.title', 'You have successfully accepted the invitation')}
                        </h5>
                    </div>
                    <Card>
                        <CardBody>
                            <p className="text-blue-granite">
                                {i18next.t('pages.notFound.text', 'You have successfully accepted the invitation. Please download the application for\n' + 'further usage. Your temporary credentinals was sent on your email.')}
                            </p>

                            <a href="https://play.google.com/store/apps/details?id=app.wabamsg.io" target="_blank" rel="nofollow">
                                <img src="/googleplay.png" alt="googleplay"
                                     className="btn-googleplay w-50"/>

                            </a>
                        </CardBody>
                    </Card>
                </Col>
            </div>
        </div>
        <img src={bg} alt="bg-phone-right" className="custom-bg-phone" />

    </>;
}


const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(NotFound);
